import * as API from './'
//基地址
export default {
  getCode:params =>{
    return API.POST(`/app/v1/login/get/code`,params)
  },
  loginIn:params =>{
  return API.POST(`/app/v1/login/verify`,params)
  },
    //个人信息
  psnInfo:params =>{
    return API.GET(`/ele/v1/real/name/psn/info`,params)
  },
  //企业信息
  entInfo:params =>{
    return API.GET(`/ele/v1/real/name/ent/info`,params)
  },
  psnCode:params =>{
  return API.POST(`/ele/v1/real/name/psn`,params)
  },
  validateCode:params =>{
  return API.POST(`/ele/v1/real/name/psn/validate/code`,params)
  },
  nameent:params =>{
  return API.POST(`/ele/v1/real/name/ent`,params)
  },
  listall:params =>{
  return API.POST(`/ele/v1/real/name/ent/list/all`,params)
  },
  listsubbranch:params =>{
  return API.GET(`/ele/v1/support/bank/list/subbranch`,params)
  },
  entlist:params =>{
  return API.GET(`/ele/v1/real/name/ent/list`,params)
  },
  entpayment:params =>{
  return API.POST(`/ele/v1/real/name/ent/payment`,params)
  },
  contractall:params =>{
  return API.GET(`/ele/v1/contract/sign/info/all`,params)
  },
  // contractsign:params =>{
  // return API.GET(`/ele/v1/contract/sign/info`,params)
  // },
  contractsign:params =>{
    return API.POST(`/ele/v1/contract/sign/info/list`,params)
  },
  signaddress:params =>{
  return API.GET(`/ele/v1/contract/sign/address`,params)
  },
  overaddress:params =>{
  return API.GET(`/ele/v1/contract/sign/over/address`,params)
  },
  signGuarantee:params =>{
  return API.POST(`/ele/v1/contract/sign/guarantee`,params)
  },
  signExtension:params =>{
    return API.POST(`/ele/v1/contract/sign/update`,params)
  },
  getWxUrl:params =>{
    return API.POST(`/user/login/v1/wx/auth/geturl`,params)
  },
  getOpenId:params =>{
    return API.POST(`/user/login/v1/wx/openid/get`,params)
  },
  signJiayuan:params =>{
    return API.POST(`/ele/v1/contract/sign/jiayuan`,params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_sign.js